import React, { FC } from 'react';
import styled from 'styled-components';
import { Button, Typography } from '@beeline.com/bp-design-system';
import { useEditorsIntl } from '../designer/editors/translations/useEditorsIntl';
export const ExternalComplete: FC<React.PropsWithChildren<{}>> = () => {
  const intl = useEditorsIntl();
  return (
    <StyledContainer>
      <Typography variant="h1">{intl.pleaseCloseWindow}</Typography>
      <Button color="primary" variant="contained" onClick={() => window.close()}>
        {intl.close}
      </Button>
    </StyledContainer>
  );
};
const StyledContainer = styled.div`
  text-align: center;
  button {
    margin: 1rem 0;
  }
`;
